module.exports = __webpack_public_path__ + "img/4.783c930e.jpg";